import { mdiAndroid, mdiCheckAll, mdiDevTo, mdiEarth, mdiHumanMaleBoardPoll } from "@mdi/js";
import Icon from "@mdi/react";
import "animate.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export default function Atuacao() {
    useEffect(() => {
        AOS.init({ once: true });
    }, []);
    return (
        <section id="services" className="services section">
            <div className="container section-title" data-aos="fade-up">
                <div>
                    <span>Áreas de</span> <span className="description-title">Atuação</span>
                </div>
            </div>

            <div className="container">
                <div className="row gy-4">
                    {/* Serviço 1 */}
                    <div className="col-md-6" data-aos="fade-right">
                        <div className="service-item">
                            <div className="service-header">
                                <div className="icon-wrapper">
                                    <Icon path={mdiDevTo} size={1.8} />
                                </div>
                            </div>
                            <h3>Desenvolvimento de Software</h3>
                            <p>Segurança e performance garantidas.</p>

                            <ul className="feature-list">
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> APIs em .NET 8
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Testes automatizados
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Performance desde o início
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Serviço 2 */}
                    <div className="col-md-6" data-aos="fade-left">
                        <div className="service-item">
                            <div className="service-header">
                                <div className="icon-wrapper">
                                    <Icon path={mdiAndroid} size={1.8} />
                                </div>
                            </div>
                            <h3>Aplicativos / Web Apps</h3>

                            <p>As melhoras ferramentas para o seu projeto.</p>

                            <ul className="feature-list">
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Front-end moderno
                                    (React/Next.js ou Angular)
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> UX fluida
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Integração segura com seu
                                    back-end
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Serviço 3 */}
                    <div className="col-md-6" data-aos="fade-right">
                        <div className="service-item">
                            <div className="service-header">
                                <div className="icon-wrapper">
                                    <Icon path={mdiEarth} size={1.8} />
                                </div>
                            </div>
                            <h3>Sites e Landing Pages</h3>

                            <p>Seu negócio no mundo para todo mundo ver.</p>

                            <ul className="feature-list">
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Websites rápidos
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Abordagem Mobile-first{" "}
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Otimização para SEO
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Serviço 4 */}
                    <div className="col-md-6" data-aos="fade-left">
                        <div className="service-item">
                            <div className="service-header">
                                <div className="icon-wrapper">
                                    <Icon path={mdiHumanMaleBoardPoll} size={1.8} />
                                </div>
                            </div>
                            <h3>Consultoria em TI</h3>
                            Arquitetura, DevOps (Azure DevOps), Cloud AWS, otimização de custos e revisão de
                            código/pipelines.
                            <p>Nosso negócio é ver o seu negócio crescendo.</p>
                            <ul className="feature-list">
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Arquitetura
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> DevOps (Azure DevOps)
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Cloud AWS
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Otimização de custos
                                </li>
                                <li>
                                    <Icon className="listIcon" path={mdiCheckAll} size={1} /> Revisão de
                                    código/pipelines
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
